import { UNKNOWN } from "../Constants/locations";
export var getLocationId = function getLocationId(location) {
  if (!location) {
    return UNKNOWN;
  }
  if (location.type === 'CITY' || location.type === 'STATE' || location.type === 'COUNTRY') {
    return String(location.id);
  }
  var addressComponent = location.addressComponents && location.addressComponents.find(function (loc) {
    return loc.type === 'CITY';
  });
  if (addressComponent) {
    return addressComponent.id;
  }
  return UNKNOWN;
};
export default {
  getLocationId: getLocationId
};